export enum ReviewOrderMerchZone {
  experience = 'ReviewOrderMerchZone',
  topSellerVariant = 'ReviewOrderMerchZone-Top-Seller',
  trendingNowVariant = 'ReviewOrderMerchZone-Trending-Now',
}
export const FREQUENTLY_BOUGHT_TOGETHER_EXPERIENCE =
  'ReviewOrderFrequentlyBoughtTogether';

export const MERCH_ZONE_MAX_PRODUCTS = 12;
export const MERCH_FBT_MAX_PRODUCTS = 12;

export const WIN_BACKS_FEATURE = 'revman winbacks';

export const BROWSE_TOP_SELLER_EXPERIENCE = 'BrowseTopSeller';
export const BROWSE_RECENTLY_VIEWED_EXPERIENCE = 'BrowseRecentlyViewed';

export const MONETATE_VARIANT = 'monetate';

export const DEFAULT_LAST_FOUR_BUYS_LOOKBACK_DAYS = 180;
export const EXTENDED_LAST_FOUR_BUYS_LOOKBACK_DAYS = 365;

export const GUEST_LANDING_PAGE_VARIANT_A = 'A';
export const GUEST_LANDING_PAGE_VARIANT_B = 'B';
